var trackingConfig = {
    ga4gid: 'G-Y61JNJM4M0',
    prefix: 'conversional',
    trackerName: 'conversionalTracker',
    ga4TrackerName: 'conversionalGA4Tracker',
    journeyId: null
};
export default trackingConfig;
